<template>
    <div>
    
    
        <h3 class="header-title">Class</h3>
        <label>Let’s see your class progress.</label>
        <br />
        <div class="custom-explore">
            <div>
                <CRow>
                    <CCol sm="12">
                        <div style="width: 80%" class="float-left">
                            <span class="float-left">
                                                                    <img
                                                                      src="../assets/img/iconnoti.svg"
                                                                      class="ml-5 mr-2 mb-3 mt-3"
                                                                    />
                                                                    <span class="text-white mt-3 mb-2"> | </span>
                            </span>
    
                            <span class="float-left">
                                                                    <label class="ml-2 text-white mt-3 mb-2"
                                                                      >Please check your students attendance for today class
                                                                      <br /><br />
                                                                      <CButton type="btn" class="btn-bg-white"
                                                                        >Check Now</CButton
                                                                      ></label
                                                                    >
                                                                    <br />
                                                                  </span>
                        </div>
                        <div style="width: 20%" class="float-right p-0">
                            <br />
                            <img src="../assets/img/icontriangle.svg" class="ml-5 mr-2" style="position: absolute; top: 0; right: 100px; bottom: 0;opacity:0.2" />
                        </div>
                    </CCol>
                </CRow>
            </div>
        </div>
    
        <CRow>
            <CCol sm="12">
                <div v-if="Busy == true">
                    <CCol sm="12" md="12">
                        <div class="app flex-row align-items-center">
                            <div class="container d-flex justify-content-center">
                                <PulseLoader float />
                            </div>
                        </div>
                    </CCol>
                </div>
                <div v-else>
                    <CButton type="btn" class="custom-explore text-white mt-3" @click="openCreateEvents()">+ Create Schedule</CButton>
                    <CCard class="mt-2" style="padding: 10px;border:none;border-bottom: 1px solid #ccc;">
                        <CRow>
                            <CCol sm="6"> <label class="mt-2">Filter by Teacher</label>
                                <v-select v-model="selectedTeacher" :options="teacherOptions" label="Name" placeholder="--Please Select Teacher--" class="custom-vselect no-bordered"></v-select>
                            </CCol>
                            <CCol sm="6">
                                <label class="mt-2">Filter by Subject</label>
                                <v-select v-model="selectedSubject" :options="subjectOptions" label="Name" placeholder="--Please Select Subject--" class="custom-vselect no-bordered"></v-select>
                            </CCol>
    
                        </CRow>
                    </CCard>
    
                    <div class="calendar">
                        <CCol sm="12" class="sticky-header">
                            <CRow class="bg-white" style="padding: 10px;border:none;border-bottom: 1px solid #ccc;border-radius: 16px;">
                                <div style="width:10%" class="p-1" @click="showPreviousMonth">
                                    <div class="text-center p-2 text-white custom-explore"><span class="date">&lt;</span></div>
                                </div>
                                <div style="width:79%" class="p-1" @click="openListEvents(currentMonth, currentYear)">
                                    <h4 class="text-center mt-1">{{ currentMonth }} {{ currentYear }}</h4>
                                </div>
                                <div style="width:10%" class="p-1 text-right" @click="showNextMonth">
                                    <div class="text-center p-2 text-white custom-explore"> <span class="date">&gt;</span></div>
                                </div>
                            </CRow>
    
                        </CCol>
                        <CCol sm="12" class="sticky-header-btn d-md-none d-lg-none bg-white mt-2" style="border:none;border-radius: 16px;">
                            <CRow class="justify-content-between align-items-center">
                                <div class="text-center custom-explore p-2 text-white d-md-none d-lg-none pl-2" @click="showPreviousWeek">
                                    <span>&lt; Prev Week</span>
                                </div>
                                <div class="text-center custom-explore p-2 text-white d-md-none d-lg-none pr-2" @click="showNextWeek">
                                    <span>Next Week &gt;</span>
                                </div>
                            </CRow>
                        </CCol>
    
    
    
                        <div class="calendar-header mt-2">
                            <CRow>
                                <CCol sm="1" @click="showPreviousWeek">
                                    <div class="text-center mt-2 custom-explore p-2 text-white d-sm-down-none"><span>&lt;</span></div>
                                </CCol>
                                <CCol sm="10">
                                    <div ref="scrollableDates" class="scrollable-dates">
                                        <div class="day" v-for="(day, index) in displayedDays" :key="day.fullDate" :class="{ 
                                                'current-day-name': isCurrentDay(day), 
                                                'selected-day-name': isSelectedDay(day) 
                                            }" @click="selectDay(day)" ref="currentDay">
                                            <div class="date" :class="{
                                                'current-date': isCurrentDay(day),
                                                'selected-date': isSelectedDay(day),
                                                'not-current-date': !isCurrentDay(day) && !isSelectedDay(day)
                                            }">
                                                {{ day.date }}
                                            </div>
                                            <div class="day-name">{{ day.name }}</div>
                                        </div>
                                    </div>
                                </CCol>
                                <CCol sm="1" @click="showNextWeek">
                                    <div class="text-center mt-2 custom-explore p-2 text-white d-sm-down-none">
                                        <span>&gt;</span>
                                    </div>
                                </CCol>
                            </CRow>
    
    
                        </div>
    
                        <div class="calendar-body">
                            <div class="time-slot" v-for="time in timeSlots" :key="time">
                                <div class="time">{{ time }}</div>
                                <div class="events">
                                    <div v-for="event in filteredEvents.filter(e => isTimeWithinSlot(e.startDate, time))" :key="event.title" class="event" :class="event.ThemeColor" @click="openDetailEvent(event)">
                                        {{ event.title }} - {{ event.Teacher }} - {{ event.startDate | moment("HH:mm A") }} - {{ event.endDate | moment("HH:mm A") }}
                                    </div>
                                </div>
                            </div>
                        </div>
    
    
    
                    </div>
    
    
    
                </div>
    
            </CCol>
        </CRow>
    
    
        <div v-if="OpenDetailEvent" class="popup-all backdrop-all">
            <div class="popup-all1 p-4">
                <CRow class="align-items-center mb-3">
    
                    <div style="width:100%" class="text-right">
                        <img src="../assets/img/close.png" style="max-width: 30px; cursor: pointer;" @click="closePopupCreate" />
                    </div>
                </CRow>
    
                <div v-if="ewall === 0">
    
                    <div style="width:100%">
                        <CRow>
                            <CCol sm="2">
                                <img :src="photoURLteacher" width="50px" height="50px" class="rounded-circle" />
                            </CCol>
                            <CCol sm="10">
                                <h5 class="font-weight-bold">{{ teacherName }}</h5>
                                <p class="text-muted">{{ SubjectName }}</p>
                            </CCol>
                        </CRow>
                    </div>
    
                    <div class="mb-3">
                        <label class="font-weight-bold">Class Details</label>
                        <div class="small text-muted">CLASS NAME</div>
                        <CInput v-model="SubjectName" disabled class="mb-2" />
                    </div>
    
                    <div class="mb-3">
                        <div class="small text-muted">START DATE <label class="text-muted">(Use 24Hour for Safari only)</label></div>
                        <CInput type="datetime-local" v-model="SelectedScheduleDateTime" class="mb-2" />
                    </div>
    
                    <div class="mb-4">
                        <div class="small text-muted">END DATE <label class="text-muted">(Use 24Hour for Safari only)</label></div>
                        <CInput type="datetime-local" v-model="SelectedScheduleDateTimeEnd" class="mb-4" />
                    </div>
    
                    <CRow>
                        <CCol sm="6">
                            <CButton block size="lg" color="success" @click="UpdateSchedule" class="mt-2">
                                Save Edit
                            </CButton>
                        </CCol>
                        <CCol sm="6">
                            <CButton block size="lg" color="danger" @click="DeleteSchedules()" class="mt-2">
                                Remove
                            </CButton>
                        </CCol>
                        <CCol sm="12">
                            <CButton block size="lg" color="warning" class="d-md-none d-lg-none mt-2" @click="closePopupCreate()">
                                Close
                            </CButton>
                        </CCol>
                    </CRow>
                    <br /> <br /> <br />
                </div>
                <div v-else>
                    <CAlert color="danger">Plese note : You are not allowed to reschedule on this date because this schedule already have attendance and charge ewallet to parent</CAlert>
    
                    <div style="width:100%">
                        <CRow>
                            <CCol sm="2">
                                <img :src="photoURLteacher" width="50px" height="50px" class="rounded-circle" />
                            </CCol>
                            <CCol sm="10">
                                <h5 class="font-weight-bold">{{ teacherName }}</h5>
                                <p class="text-muted">{{ SubjectName }}</p>
                            </CCol>
                        </CRow>
                    </div>
    
                    <div class="mb-3">
                        <label class="font-weight-bold">Class Details</label>
                        <div class="small text-muted">CLASS NAME</div>
                        <CInput v-model="SubjectName" disabled class="mb-2" />
                    </div>
    
                    <div class="mb-3">
                        <div class="small text-muted">START DATE <label class="text-muted">(Use 24Hour for Safari only)</label></div>
                        <CInput type="datetime-local" v-model="SelectedScheduleDateTime" class="mb-2" />
                    </div>
    
                    <div class="mb-4">
                        <div class="small text-muted">END DATE <label class="text-muted">(Use 24Hour for Safari only)</label></div>
                        <CInput type="datetime-local" v-model="SelectedScheduleDateTimeEnd" class="mb-4" />
                    </div>
    
                    <CRow>
                        <CCol sm="6">
                            <CButton block type="submit" size="lg" color="success" disabled>
                                Save Edit</CButton>
                        </CCol>
                        <CCol sm="12">
                            <CButton block size="lg" color="warning" class="d-md-none d-lg-none mt-2" @click="closePopupCreate()">
                                Close
                            </CButton>
                        </CCol>
                        <br /> <br /> <br />
                    </CRow>
    
    
                </div>
            </div>
        </div>
    
        <div v-if="OpenListEvent" class="popup-all backdrop-all">
            <div class="popup-all1 p-4">
                <CRow class="align-items-center mb-3">
    
                    <div style="width:100%" class="text-right">
                        <img src="../assets/img/close.png" style="max-width: 30px; cursor: pointer;"  @click.stop="closePopupList" />
                    </div>
                </CRow>
    
                <CCard class="custom-bg-color-yellow m-1" v-for="(item, index) in schedules" v-bind:key="item.Id">     
                    <CRow>
                        <div style="width:20%">
                            <div class="text-center text-white m-2">
                             
                               {{ item.Start | moment("DD") }}
                               <br />
                               {{ item.Start | moment("MMM YYYY") }}
    
                            </div>
                        </div>
                        <div style="width:20%">
                            <div class="text-left">
                                <img v-if="item.profileImagePath == ''" style="
                                border: 1px solid #eee;
                                width: 60px;
                                height: 60px;
                                border-radius: 50%;
                                object-fit: cover;
                              " src="../assets/img/default.png" class="grey lighten-2" />
    
                                <img v-else style="
                                border: 3px solid #ddd;
                                background: #fff;
                                width: 60px;
                                height: 60px;
                                border-radius: 50%;
                                object-fit: cover;
                              " :src="getPic(index)" class="grey lighten-2" />
                            </div>
                        </div>
                        <div style="width:60%">
                            <h6 class="text-left mt-2">
                                <strong> {{ item.title }}</strong>
                            </h6>
                            {{ item.start | moment("HH:mm") }} - {{ item.end | moment("HH:mm") }}
                        </div>
    
                    </CRow>
                </CCard>
            </div>
        </div>
    
        <div v-if="OpenCreateEvent" class="popup-all backdrop-all">
            <div class="popup-all1 p-4">
                <CRow class="align-items-center mb-3">
    
                    <div style="width:100%" class="text-right">
                        <img src="../assets/img/close.png" style="max-width: 30px; cursor: pointer;" @click="closePopupCreateEvent" />
                    </div>
                </CRow>
    
                <div class="p-1">
                    <label class="mt-1">Create Schedule</label>
                    <br />
    
                    <label class="mt-3">Schedule Name</label>
                    <v-select v-model="selectedSubjects" :options="subjectsData" label="Name" placeholder="--Please Select Subject--" class="custom-vselect no-bordered"></v-select>
    
                    <label class="mt-3">Repeat For Every</label
                        >
                        <CCol sm="12">
                        <CRow>
                            <div style="width:70%"> <input
                            type="number"
                            v-model="intervals"
                            class="custom-input-user form-control"
                        /></div>
                            <div style="width:20%" class="ml-2 mt-3"> week</div>
                        </CRow>
                    </CCol>
                       
                       
    
                        <CRow>
                            <CCol sm="6">
                            <label class="mt-3">Start Time</label>
                    <CInput type="datetime-local" v-model="ScheduleDateTimes" />
                    </CCol>
                    <CCol sm="6">
                        <label class="mt-3">End Time</label>
                        <CInput type="datetime-local" v-model="ScheduleDateTimeEnds" />
                    </CCol>
                    </CRow>
    
                    <label class="">Theme Color</label>
                    <v-select v-model="selectedColor" :options="optionsColor" placeholder="--Please Select Theme--" class="custom-vselect no-bordered" label="Name"></v-select>
    
                    <label class="mt-2">Teacher</label>
                    <v-select v-model="selectedTeacher" :options="teachers" label="Name" placeholder="--Please Select Teacher--" class="custom-vselect no-bordered"></v-select>
                    <br />
                    <div class="text-center">
                        <CButton color="primary" size="lg" block @click="SubmitSchedule" class="custom-explore">Save
                        </CButton>
                        <br /><br />
                    </div>
                </div>
    
            </div>
        </div>
    
        <div v-if="isPopupSuccess" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                    <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                        Your data has been submitted successfully.
                    </h3>
                    <CButton class="custom-explore mt-4 text-white" @click="closeSuccess" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                </div>
            </div>
        </div>
    
    </div>
</template>



<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
import VCalendar from "v-calendar";
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.use(VuejsDialog);

import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartBar } from "@coreui/vue-chartjs";
import VueEllipseProgress from "vue-ellipse-progress";

//import "@fullcalendar/core/vdom"; // solves problem with Vite]

import { Calendar } from "vue-sweet-calendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";

Vue.use(require("vue-moment"));
import moment from "moment";

Vue.use(FullCalendar);
Vue.use(VueEllipseProgress);

export default {
    name: "CalendarView",
    components: {
        PulseLoader,
        CChartBar,
        Calendar,
        VCalendar,
        VueCal,
    },
    data() {
        return {
            //days: this.generateDays(),
            timeSlots: this.generateTimeSlots(),
            event: [
                { time: '9:00 am', description: 'Meeting Expat', startDate: '2024-10-23 09:00:00' },
                { time: '12:30 pm', description: 'Meeting Advancedcellnet', startDate: '2024-10-23 12:30:00' },
            ],
             schedule: [],
           
            selectedDate: null,

            OpenDetailEvent: false,
            SelectedScheduleDateTime: "",
            SelectedScheduleDateTimeEnd: "",
            Busy: false,
            ewall: 0,

            days: [], // All days in the month
            displayedDays: [], // Days to show for the current week
            currentWeekStart: 0, // Start index for the current week
            daysPerWeek: 7, // Number of days per week

            selectedTeacher: "SELECT TEACHER",
            teacherOptions: [],

            selectedSubject: "SELECT SUBJECT",
            subjectOptions: [],


            currentMonthIndex: new Date().getMonth(), // Starts with the current month
            currentYear: new Date().getFullYear(),
            months: [
                'January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'
            ],
            OpenListEvent: false,
            schedules: [],
            subjectsData: [],
            teachers: [],

            OpenCreateEvent: false,
            selectedSubjects: "",
            ScheduleDateTimes: "",
            ScheduleDateTimeEnds: "",
            intervals: 1,
            optionsColor: [{
                    Id: 1,
                    Name: "blue",
                },
                {
                    Id: 2,
                    Name: "red",
                },
                {
                    Id: 3,
                    Name: "green",
                },
                {
                    Id: 4,
                    Name: "purple",
                },
                {
                    Id: 5,
                    Name: "violet",
                },
            ],
            selectedColor: "",
            isPopupSuccess: false,

            scheduleIdDetail: 0,
        };
    },
    computed: {
        filteredEvents() {
            const selectedDate = this.selectedDate || new Date().toISOString().split('T')[0];

            // Filter by date first
            let filtered = this.schedule.filter(event => event.startDate.split(' ')[0] === selectedDate);

            // Then filter by selected teacher if one is selected
            if (this.selectedTeacher && this.selectedTeacher !== "SELECT TEACHER") {
                filtered = filtered.filter(event => event.Teacher === this.selectedTeacher);
            }

            if (this.selectedSubject && this.selectedSubject !== "SELECT SUBJECT") {
                filtered = filtered.filter(event => event.title === this.selectedSubject);
            }

            console.log('Filtered Events:', filtered); // Log filtered events
            return filtered;
        },
        currentWeekDays() {
            const today = new Date();
            const firstDayOfWeek = new Date(today);
            firstDayOfWeek.setDate(today.getDate() - today.getDay() + (today.getDay() === 0 ? -6 : 1)); // Get Monday of the current week

            const lastDayOfWeek = new Date(firstDayOfWeek);
            lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6); // Sunday of the current week

            return this.days.filter(day => {
                const dayDate = new Date(day.fullDate);
                return dayDate >= firstDayOfWeek && dayDate <= lastDayOfWeek;
            });
        },
        isFirstWeek() {
            return this.currentWeekStart === 0;
        },
        isLastWeek() {
            return this.currentWeekStart + this.daysPerWeek >= this.days.length;
        },


        currentMonth() {
            return this.months[this.currentMonthIndex];
        },
        displayedDaysComputed() {
            // This computed property generates displayed days based on current month/year
            const daysInMonth = new Date(this.currentYear, this.currentMonthIndex + 1, 0).getDate();
            return Array.from({ length: daysInMonth }, (v, i) => {
                return {
                    date: i + 1,
                    fullDate: new Date(this.currentYear, this.currentMonthIndex, i + 1),
                    name: new Date(this.currentYear, this.currentMonthIndex, i + 1).toLocaleString('default', { weekday: 'long' })
                };
            });
        },
    },
    watch: {
        SelectedScheduleDateTime(newVal) {
            // Convert newVal to the desired format before updating the v-model
            this.SelectedScheduleDateTime = convertToISOFormat(newVal);
        },
        SelectedScheduleDateTimeEnd(newVal) {
            // Convert newVal to the desired format before updating the v-model
            this.SelectedScheduleDateTimeEnd = convertToISOFormat(newVal);
        },
    },




    async mounted() {

        let isAuth = await this.UserAuth();

        if (isAuth) {
            this.Busy = true; // Show loading
            await this.GetScheduleStudent(); // Fetch schedules
             this.days = this.generateDays(); // Generate all days for the current month
             this.currentWeekStart = this.getStartOfCurrentWeek(); // Set to the start of the current week
            await this.updateDisplayedDays(); // Update displayed days for the current week
            await this.scrollToCurrentWeek(); // Show the current week in view
            await this.GetTeacher();
            await this.GetSubject();
            this.generateDays();
            this.Busy = false; // Hide loading
        } else {
            this.GoToLogin();
        }

    },
    methods: {
        isTimeWithinSlot(eventStartDate, slotTime) {
    const eventTime = new Date(eventStartDate).getTime(); // Convert to timestamp
    const slotTimeStart = new Date(`${eventStartDate.split(' ')[0]} ${slotTime}`).getTime(); // Slot time as timestamp
    const slotTimeEnd = slotTimeStart + 30 * 60 * 1000; // 30 minutes later

    return eventTime >= slotTimeStart && eventTime < slotTimeEnd;
  },
        async GetScheduleStudent() {
            this.Busy = true;
            this.$API
                .get(this.$ViewSchedule, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status === 200 && response.data) {
                        console.log('API Response:', response.data); // Add this line to log the response
                        this.Busy = false;
                        this.schedule = response.data;

                        var teacherNames = _.uniq(_.map(response.data, "Teacher"));
                        teacherNames.sort(function(a, b) {
                            return a.toLowerCase().localeCompare(b.toLowerCase());
                        });
                        this.teacherOptions = teacherNames;
                        this.teacherOptions.unshift("SELECT TEACHER");

                        var subjectNames = _.uniq(_.map(response.data, "title"));
                        subjectNames.sort(function(a, b) {
                            return a.toLowerCase().localeCompare(b.toLowerCase());
                        });
                        this.subjectOptions = subjectNames;
                        this.subjectOptions.unshift("SELECT SUBJECT");


                    }
                });
        },
        generateDays() {
            const days = [];
            const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

            // Use currentMonthIndex and currentYear
            const firstDayOfMonth = new Date(this.currentYear, this.currentMonthIndex, 1);
            const lastDayOfMonth = new Date(this.currentYear, this.currentMonthIndex + 1, 0);

            let currentDate = new Date(firstDayOfMonth);

            while (currentDate <= lastDayOfMonth) {
                // Use moment to handle the local date formatting
                const formattedDate = moment(currentDate).format('YYYY-MM-DD');
                days.push({
                    date: currentDate.getDate(),
                    name: dayNames[currentDate.getDay()],
                    fullDate: formattedDate // Use moment to get the local full date
                });

                currentDate.setDate(currentDate.getDate() + 1);
            }

            return days;
        },


        showPreviousWeek() {
            if (this.currentWeekStart - this.daysPerWeek >= 0) {
                this.currentWeekStart -= this.daysPerWeek;
                this.updateDisplayedDays();
                this.scrollToCurrentWeek();
            }
        },
        showNextWeek() {
            if (this.currentWeekStart + this.daysPerWeek < this.days.length) {
                this.currentWeekStart += this.daysPerWeek;
                this.updateDisplayedDays();
                this.scrollToCurrentWeek();
            }
        },
        updateDisplayedDays() {
            // Update displayedDays to show the current week based on currentWeekStart
            this.displayedDays = this.days.slice(this.currentWeekStart, this.currentWeekStart + this.daysPerWeek);
        },
        scrollToCurrentWeek() {
            this.$nextTick(() => {
                const scrollableDates = this.$refs.scrollableDates;
                const currentDateElement = this.$refs.currentDay ? this.$refs.currentDay[0] : null; // Use ref for current day
                if (currentDateElement) {
                    const scrollOffset = currentDateElement.offsetLeft - scrollableDates.offsetWidth / 2 + currentDateElement.offsetWidth / 2;
                    scrollableDates.scrollTo({
                        left: scrollOffset,
                        behavior: 'smooth',
                    });
                }
            });
        },
        scrollToCurrentDay() {
            const currentDayElement = this.$refs.currentDay ?.[0]; // Access the element for the current day
            const scrollableDates = this.$refs.scrollableDates;

            if (currentDayElement && scrollableDates) {
                // Calculate the scroll position for the current day
                const scrollOffset = currentDayElement.offsetLeft - scrollableDates.offsetWidth / 2 + currentDayElement.offsetWidth / 2;
                scrollableDates.scrollTo({
                    left: scrollOffset,
                    behavior: 'smooth'
                });
            }
        },
        generateTimeSlots() {
            const times = [];
            let hour = 8;
            let minute = 0;
            const period = ['AM', 'PM'];
            while (hour < 24) {
                const formattedTime = `${hour % 12 || 12}:${minute === 0 ? '00' : minute} ${period[Math.floor(hour / 12)]}`;
                times.push(formattedTime);
                minute += 30;
                if (minute === 60) {
                    minute = 0;
                    hour++;
                }
            }
            times.push('12:00 AM');
            return times;
        },
        isCurrentDay(day) {
            // Use moment to handle the local date and comparison
            const today = moment().format('YYYY-MM-DD');
            return day.fullDate === today;
        },
        isSelectedDay(day) {
            return day.fullDate === this.selectedDate;
        },
        selectDay(day) {
            this.selectedDate = day.fullDate;
        },
        formatTimeTo12Hour(time) {
            const [hours, minutes] = time.split(':');
            const period = hours >= 12 ? 'pm' : 'am';
            const formattedHours = hours % 12 || 12;
            return `${formattedHours}:${minutes} ${period}`;
        },
        formatTimeTo24Hour(time) {
            return moment(time, 'hh:mm A').format('HH:mm');
        },
        openDetailEvent(event) {
            this.selectedEvent = event; // Store the clicked event
            this.OpenDetailEvent = true; // Open the popup
            this.OpenDetailSchedule(event.ID);

        },
        closePopupCreate() {
            this.OpenDetailEvent = false; // Close the popup
            this.selectedEvent = null; // Clear the selected event
        },
        openListEvents(month, year) {
            // Construct the start date with the selected month and year, setting the day to '01'
            const formattedMonth = moment(month, "MMMM").format("MM"); // Convert month name to two-digit format
            const startDate = `${year}-${formattedMonth}-01`; // Construct the date string

            // Make your API call with the constructed start date
            this.$API
                .get(this.$ViewScheduleByMonthYear + "?start=" + startDate, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.Busy = false;
                        this.schedules = response.data;
                        this.getPic(this.schedules);
                    } else {
                        console.log(response.data.detail);
                    }
                });
            this.OpenListEvent = true;
        },
        getPic(index) {
            return "https://pickiddo.com/" + this.schedules[index].ProfilePicturePath;
        },
        closePopupList() {
            this.OpenListEvent = false; // Close the popup
            this.selectedEvent = null; // Clear the selected event
        },
        OpenDetailSchedule(ID) {
            this.popuplist = false;
            this.editschedule = true;

            this.$API
                .get(this.$GetAttendanceEwallet + "?scheduleId=" + ID, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.ewall = response.data;
                    }
                });

            this.$API
                .get(this.$EditSchedule + "?scheduleID=" + ID, {
                    withCredentials: true,
                })
                .then((response) => {
                    this.info = response.data;
                    console.log(this.info);

                    if (response.status == 200 && this.info != null) {
                        this.ClassName = this.info.ClassName;
                        this.SubjectName = this.info.SubjectName;
                        this.SelectedScheduleDateTime = this.info.ScheduleDateTime;
                        this.SelectedScheduleDateTimeEnd = this.info.ScheduleDateTimeEnd;

                        this.TuitionSubjectID = this.info.TuitionSubjectID;
                        this.picturePath = this.info.profileImagePath;
                        this.teacherName = this.info.TeacherName;
                        this.scheduleIdDetail = ID;

                        console.log("test" + this.teacherName);

                        this.photoURLteacher = "https://pickiddo.com/" + this.picturePath;
                    } else {
                        console.log(this.info.detail);
                    }
                });
        },
        RefreshData() {
      this.GetScheduleStudent();
      this.selectedSubject = "";
      this.selectedTeacher = "";
    },
        UpdateSchedule() {
            const formData = new FormData();
            if (this.SelectedScheduleDateTime > this.SelectedScheduleDateTimeEnd) {
                this.errorDate = true;
                this.labelMessageError = 'Error: Due to End Date is less than Start Date';
            } else if (this.SelectedScheduleDateTimeEnd == this.SelectedScheduleDateTime) {
                this.errorDate = true;
                this.labelMessageError = 'Error: Due to End Date is equal to Start Date';
            } else {
                formData.append("scheduleID", this.scheduleIdDetail);
                formData.append(
                    "scheduleTime",
                    moment(this.SelectedScheduleDateTime).format("DD/MM/YYYY HH:mm")
                );
                formData.append(
                    "scheduleTimeEnd",
                    moment(this.SelectedScheduleDateTimeEnd).format("DD/MM/YYYY HH:mm")
                );
                formData.append("subjectID", this.TuitionSubjectID);

                return this.$API
                    .post(this.$UpdateSchedules, formData, {
                        withCredentials: true,
                    })
                    .then((response) => {
                        if (response.status == 200 && response.data != null) {
                            //this.successModal = true;
                            this.RefreshData();
                            this.OpenDetailEvent = false;
                            this.isPopupSuccess = true;
                        }
                    })
                    .catch((error) => {
                        if (error.response) {
                            console.log(error.response.status);
                            this.Error = true;
                            this.Message = error;
                            this.Message = "Error";
                        }
                    });
            }
        },
        DeleteSchedules() {
            const formData = new FormData();

            formData.append("Id", this.scheduleIdDetail);

            return this.$API
                .post(this.$DeleteSchedule, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    this.info = response.data;

                    if (response.status == 200) {
                        this.RefreshData();
                        this.OpenDetailEvent = false;
                            this.isPopupSuccess = true;
                    } else console.log("Error Deleting");
                })
                .catch((error) => {
                    console.log(error);
                });
        },
       
        getStartOfCurrentWeek() {
    const today = new Date();
    const firstDayOfMonth = new Date(this.currentYear, this.currentMonthIndex, 1);
    const daysDifference = Math.abs(today.getDate() - firstDayOfMonth.getDate());
    return Math.floor(daysDifference / 7) * 7; // Adjust this logic as necessary
},


showPreviousMonth() {
        if (this.currentMonthIndex > 0) {
            this.currentMonthIndex--;
        } else {
            this.currentMonthIndex = 11; // Wrap to December
            this.currentYear--;
        }
        this.updateMonthData();
    },
    showNextMonth() {
        if (this.currentMonthIndex < 11) {
            this.currentMonthIndex++;
        } else {
            this.currentMonthIndex = 0; // Wrap to January
            this.currentYear++;
        }
        this.updateMonthData();
    },
    updateMonthData() {
        this.days = this.generateDays(); // Regenerate days for the new month
        this.updateSelectedDateInNewMonth();
        this.updateDisplayedDays();
        this.updateFilteredEvents(); // Update events for the new month
    },
    updateSelectedDateInNewMonth() {
        if (this.selectedDate) {
            const previousDay = new Date(this.selectedDate).getDate();
            const lastDayOfNewMonth = new Date(this.currentYear, this.currentMonthIndex + 1, 0).getDate();
            const dayToSelect = Math.min(previousDay, lastDayOfNewMonth);

            const selectedDayObject = this.days.find(day => day.date === dayToSelect);
            if (selectedDayObject) {
                this.selectedDate = selectedDayObject.fullDate;
            }
        }
    },
    updateFilteredEvents() {
        const startOfMonth = new Date(this.currentYear, this.currentMonthIndex, 1);
        const endOfMonth = new Date(this.currentYear, this.currentMonthIndex + 1, 0);

        this.filteredEvents = this.allEvents.filter(event => {
            const eventDate = new Date(event.startDate);
            return eventDate >= startOfMonth && eventDate <= endOfMonth;
        });

        console.log("Filtered events for month:", this.currentMonthIndex, this.currentYear, this.filteredEvents);
    },
        GetTeacher() {
            this.Busy = true;
            this.$API
                .get(this.$ViewTeacher, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.Busy = false;
                        this.teachers = response.data;
                        this.teachers.sort((a, b) => {
                    // Convert names to lowercase for case-insensitive sorting
                    const nameA = a.Name ? a.Name.toLowerCase() : "";
                    const nameB = b.Name ? b.Name.toLowerCase() : "";

                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    return 0;
                });

                        this.getPic(this.teachers);
                    }
                });
        },
        GetSubject() {
            return this.$API
                .get(this.$GetListSubjectTc, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.subjectsData = response.data;
                    }
                });
        },
        closePopupCreateEvent() {
            this.OpenCreateEvent = false; // Close the popup
        },
        openCreateEvents() {

            this.OpenCreateEvent = true;
        },
        async SubmitSchedule() {
            this.Busy = true;
            const formData = new FormData();

            formData.append("TuitionSubjectId", this.selectedSubjects.SubjectId);

            formData.append("ScheduleDateTime", this.ScheduleDateTimes);

            formData.append("ScheduleDateTimeEnd", this.ScheduleDateTimeEnds);

            formData.append("TeacherId", this.selectedTeacher.Id);
            formData.append("ThemeColor", this.selectedColor.Name);

            formData.append("interval", this.intervals);
            return this.$API
                .post(this.$InsertScheduleNew, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.isPopupSuccess = true;
                        this.OpenCreateEvent = false;
                        this.GetScheduleStudent();
                        this.selectedTeacher= "";
                        this.Busy = false;
                    } else {
                        this.Busy = false;
                        this.$dialog.alert("Error to save ").then(function() {});
                    }
                })
                .catch((error) => {
                    this.Busy = false;
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        closeSuccess() {
            this.isPopupSuccess = false;
        }


    }
};
</script>


<style>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap");
</style>



<style scoped>
.calendar-body {
    display: block !important;
}
</style>
